import { Stack } from '@mantine/core'
import { OrderByType } from '@v2/commons/interface/enums'

import { Icons } from 'src/common/components'

interface FilterChevronsProps {
  field: string
  filterOrderBy: { field: string; orderBy: OrderByType }
  handleOrderBy: (field: string, orderBy: OrderByType) => void
}

const FilterChevrons = ({
  field,
  filterOrderBy,
  handleOrderBy,
}: FilterChevronsProps) => {
  const handleClick = () => {
    if (filterOrderBy.field !== field || !filterOrderBy.orderBy) {
      handleOrderBy(field, 'ASC')
    } else if (filterOrderBy.orderBy === 'ASC') {
      handleOrderBy(field, 'DESC')
    } else {
      handleOrderBy('', undefined)
    }
  }

  return (
    <Stack gap={6} align="center" justify="center">
      <Icons.ChevronUp
        stroke={
          filterOrderBy.field === field && filterOrderBy.orderBy === 'ASC'
            ? 'blue'
            : 'gray'
        }
        onClick={handleClick}
        style={{ cursor: 'pointer' }}
      />
      <Icons.ChevronsDown
        stroke={
          filterOrderBy.field === field && filterOrderBy.orderBy === 'DESC'
            ? 'blue'
            : 'gray'
        }
        onClick={handleClick}
        style={{ cursor: 'pointer' }}
      />
    </Stack>
  )
}

export default FilterChevrons
